/**
 * CurrencyBreakdown (FEAT-ANALYTICS-FIX, DA-BUG-0455) — renders a money report's
 * per-currency rows as a compact table. Revenue is shown PER CURRENCY and never
 * blended across currencies (owner decision: per-currency only, no FX). Reused by
 * the Transactions / Lifetime value / New-vs-returning revenue / Conversions reports.
 */
import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer } from '@chakra-ui/react';
import { Panel, fmtInt } from './components';
import { fmtMoney } from './txnFormat';

/**
 * @param {string} title   panel heading
 * @param {Array}  rows    [{ currency, ...metrics }]
 * @param {Array}  cols    [{ key, label, money? }] — money cols format with the row's currency
 */
export function CurrencyBreakdown({ title = 'By currency', rows = [], cols = [] }) {
  if (!rows || rows.length === 0) return null;
  return (
    <Panel title={title}>
      <TableContainer>
        <Table size="sm" variant="simple">
          <Thead bg="gray.50">
            <Tr>
              <Th color="gray.500">Currency</Th>
              {cols.map((c) => (
                <Th key={c.key} isNumeric color="gray.500">{c.label}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((r) => (
              <Tr key={r.currency || '—'} _hover={{ bg: 'gray.50' }}>
                <Td fontWeight="600">{r.currency || '—'}</Td>
                {cols.map((c) => (
                  <Td key={c.key} isNumeric sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {c.money ? fmtMoney(Number(r[c.key] || 0), r.currency) : fmtInt(Number(r[c.key] || 0))}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Panel>
  );
}

export default CurrencyBreakdown;
